import { render, staticRenderFns } from "./UserInfoMenu.vue?vue&type=template&id=f0bf95f0&scoped=true&"
import script from "./UserInfoMenu.vue?vue&type=script&lang=js&"
export * from "./UserInfoMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoMenu.vue?vue&type=style&index=0&id=f0bf95f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf95f0",
  null
  
)

export default component.exports